import React from 'react'
import {withTranslation} from "react-i18next";

import {
	CircularProgress,
	createStyles,
	Step,
	StepLabel,
	Stepper,
	Theme,
	Typography,
	WithStyles,
	withStyles,
  Dialog,
  DialogActions ,
  DialogContent ,
  DialogContentText,
  Button
 } from '@material-ui/core'

import moment from 'moment'
import Education from '../../DataTypes/Education'
import { FormData } from '../../DataTypes/PersonalInfoTypes'
import Race from '../../DataTypes/Race'
import SurveyAnswer from '../../DataTypes/SurveyAnswer'
import { ActivityOrNull } from '../../services/Auth/authentication.service'
import { buildPayload, encryptPayload } from '../../services/Encryption/encryption.service'
import { createNewParticipant, findParticipantInDB } from '../../services/Participant/participant.service'
import FileUploadForm from '../Forms/FileUploadForm/FileUpload'
import PersonalInfoForm from '../Forms/PersonalInfoForm/PersonalInfoForm'
import SurveyData from '../Forms/SurveyData/SurveyData'
import CustomSlide from '../Templates/CustomSlide/CustomSlide'
import Instructions from '../Templates/Instructions/Instructions'
import ConfirmParticipantInfo from '../Templates/ParticipantInfo/ParticipantInfo'
import Disability from 'src/DataTypes/Disability';
// RJRI-158: Eligibility section disabled until further notice
// import EligibilityForm from '../Forms/EligibilityForm/EligibilityForm';

interface MainProps extends WithStyles<typeof styles> {
	activity: ActivityOrNull
  t: any
}

interface MainState {
	direction: 'right' | 'left'
	currentStep: number
	participantData: FormData
	loading: boolean
  finish: 'default' | 'enrollment' | 'failure'
  participantDialogOpen: boolean
}

const STEPS = [
  "main.step.instructions",
  // RJRI-158: Eligibility section disabled until further notice
  // "main.step.eligibility",
  "main.step.personal",
  "main.step.document",
  "main.step.employment",
  "main.step.review",
  "main.step.finish"
]


export class Main extends React.Component<MainProps, MainState> {
  public requestBody: any
  public matchedParticipant: any
	public readonly state: MainState = {
		direction: 'left',
		currentStep: -1,
    finish: 'default',
    participantData: new FormData(
      this.props.activity ? this.props.activity.activityCode : '' ,
			this.props.activity ? this.props.activity.siteCode : '',
      this.props.activity ? this.props.activity.pk : '',
      Education.NA.key
    ),
		loading: false,
    participantDialogOpen: false
	}

	setupInitialStep = () => {
		setTimeout(() => {
			this.setState({
				currentStep: 0,
			})
		}, 200)
	}

	updateParticipantData = (newParticipantData: FormData) => {
		this.setState({
			participantData: newParticipantData
		});
	}

	moveStep = (moveDirection: 'right' | 'left', step: number) => {
		this.setState({
			direction: moveDirection,
			currentStep: step
		});
		window.scrollTo(0, 0);
	}

	handleUpdateFailure = (e: Error) => {
		this.setState((prevState: MainState) => ({
      finish: 'failure',
			currentStep: prevState.currentStep + 1,
			direction: 'left',
			loading: false,
		}))
	}

	onNewParticipantSuccess = () => {
		const { search } = window.location

		this.setState((prevState: MainState) => ({
			finish: search && search.indexOf('?code=') >= 0 ? 'enrollment' : prevState.finish,
			currentStep: prevState.currentStep + 1,
			direction: 'left',
			loading: false,
			participantData: new FormData('', '', '', '') // Ensure participant data is removed after successful submit
		}))
    this.matchedParticipant = null
	}

	handleFinalMessage = () => {
    switch (this.state.finish) {
      case 'enrollment':
        return 'main.enrollmentFinalMessage';
      case 'failure':
        return 'main.failureFinalMessage';
      default:
        return 'main.defaultFinalMessage';
    }
  }

  handleEndMessage = () => {
    switch (this.state.finish) {
      case 'default':
        return 'main.defaultEndMessage';
      case 'enrollment':
        return 'main.enrollmentEndMessage';
      default:
        return 'common.blank';
    }
  }

	encryptSensitiveData = async (participantForm: FormData) => {
		const employRIPaylod = await buildPayload({
			siteCode: participantForm.siteCode,
			alienRegistrationExpirationDate: participantForm.alienRegistrationExpirationDate,
			alienNumber: participantForm.alienNumber,
			dateOfBirth: participantForm.dateOfBirth,
			zip: participantForm.zip,
			firstName: this.formatName(participantForm.firstName),
			lastName: this.formatName(participantForm.lastName),
			ssn: participantForm.ssn,
			gender: participantForm.gender ? participantForm.gender.key : '',
			address1: participantForm.address1,
			city: participantForm.city,
			state: participantForm.state,
			idDoc: participantForm.idDoc,
			idType: parseInt(participantForm.idType || '', 10),
			citizenshipType: participantForm.citizenshipType,
			homeless: participantForm.homeless,
      usePseudoSsn: participantForm.usePseudoSsn
		});
		const encryptedFields = encryptPayload(employRIPaylod, participantForm.pk);
		return encryptedFields;
	}

  formatName = (name:string | undefined | null) =>{
    if(!name){
      return name
    }
    return name.trim();
  }


	handleParticipantSubmit = async () => {

		this.setState({
			loading: true
		})

			const participantForm = {
				...this.state.participantData
			}

			 this.requestBody = {
				activityCode: participantForm.activityCode,
				firstName: this.formatName(participantForm.firstName),
				middleInitial: participantForm.middleInitial,
				lastName: this.formatName(participantForm.lastName),
				dateOfBirth: (participantForm.dateOfBirth)? moment(participantForm.dateOfBirth).format("YYYY-MM-DD"):null,
				homeless: participantForm.homeless,
				address1: participantForm.address1,
		    address2: participantForm.address2,
		    city: participantForm.city,
		    state: participantForm.state,
		    zip: participantForm.zip,
		    mailingAddress1: participantForm.mailingAddress1,
		    mailingAddress2: participantForm.mailingAddress2,
		    mailingCity: participantForm.mailingCity,
		    mailingState: participantForm.mailingState,
		    mailingZip: participantForm.mailingZip,
		    phoneNumber: participantForm.phoneNumber ? participantForm.phoneNumber.replace(/-/g, '').trim() : null,
		    email: participantForm.email? participantForm.email.trim().toLowerCase(): participantForm.email,
		    races: participantForm.races.length > 0 ?
		    	participantForm.races.map((r: Race) => {
		    		return r.key;
		    	}) : null,
        disabilities: participantForm.disabilities.length > 0 ?
        participantForm.disabilities.map((r: Disability) => {
          return r.key;
        }) : [],
		    ethnicity: participantForm.ethnicity ? participantForm.ethnicity.key : null,
		    gender: participantForm.gender ? participantForm.gender.key : null,
        preferredLanguage: participantForm.preferredLanguage ? participantForm.preferredLanguage.key : null,
		    highestGrade: participantForm.highestGrade,
      	attendingSchool: participantForm.attendingSchool ? participantForm.attendingSchool.key : null,
      	currentSchool: null,
      	employer: participantForm.employer,
      	layoffEmployer: participantForm.layoffEmployer,
      	layoffDate: participantForm.layoffDate ? moment(participantForm.layoffDate).format("YYYY-MM-DD") : null,
        formLanguage: participantForm.formLanguage,
			}

			// RJRI-158: Removed 'covid', 'acceptedCovid', 'quest' from surveyFields (Eligibility section disabled)
			const surveyFields = ['veteran', 'ell', 'attendingSchool',
						'currentlyEmployed', 'beingLaidOff', 'higherWage', 'betterSkills', 'familyDependent', 'working', 'disabilityStatus'];

			surveyFields.forEach((s) => {
				if(participantForm[s] === SurveyAnswer.YES){
					this.requestBody[s] = 1;
				} else if(participantForm[s] === SurveyAnswer.NO){
					this.requestBody[s] = 0;
				} else if(participantForm[s] === SurveyAnswer.DND){
					this.requestBody[s] = 2;
				} else {
					this.requestBody[s] = null;
				}
			});

			// Citizenship type
			if(!participantForm.citizenshipType){
				this.requestBody.citizen = null;
			} else if(participantForm.citizenshipType === '1'){
				this.requestBody.citizen = true;
			} else {
				this.requestBody.citizen = false;
			}

			// Employment type
			if(!participantForm.employmentType || participantForm.employmentType.toString() === 'NA'){
				this.requestBody.employmentType = null;
			} else{
				this.requestBody.employmentType = participantForm.employmentType.key;
			}

			// Education
			if(!participantForm.education || participantForm.education.toString() === 'NA'){
				this.requestBody.education = null;
			} else {
				this.requestBody.education = participantForm.education.key;
			}

      // Search in DB
      let participantDBrecord: any
      try {
        participantDBrecord = await findParticipantInDB(this.requestBody)
      } catch (error) {
        console.log(`ERROR from findParticipantInDB ERROR: ${JSON.stringify(error)}`)
      }
      if(participantDBrecord && participantDBrecord.status === 200 && participantDBrecord.data){
        participantDBrecord = participantDBrecord.data
        if(participantDBrecord && participantDBrecord.participant && participantDBrecord.participant.length>0){
          if(participantDBrecord.fieldsMatched && participantDBrecord.fieldsMatched.length === 3){
            this.matchedParticipant = participantDBrecord.participant.find((participant:any)=>participant.external_id)
            if(!this.matchedParticipant){
              this.matchedParticipant = participantDBrecord.participant[0]
            }
          }
          else{
            if(this.requestBody.email){
              this.matchedParticipant = participantDBrecord.participant.find((participant:any)=>participant.email && participant.email.toLowerCase().trim()===this.requestBody.email.toLowerCase().trim() && participant.external_id)
              if(!this.matchedParticipant){
                this.matchedParticipant = participantDBrecord.participant.find((participant:any)=>participant.email && participant.email.toLowerCase().trim()===this.requestBody.email.toLowerCase().trim())
              }
            }
            if(!this.matchedParticipant && this.requestBody.phoneNumber){
              this.matchedParticipant = participantDBrecord.participant.find((participant:any)=>participant.phone && participant.phone.trim()===this.requestBody.phoneNumber.trim() && participant.external_id)
              if(!this.matchedParticipant){
                this.matchedParticipant = participantDBrecord.participant.find((participant:any)=>participant.phone && participant.phone.trim()===this.requestBody.phoneNumber.trim())
              }
            }
          }
        }
        if(this.matchedParticipant){
          this.setState((prevState)=>{
            return {
              ...prevState,
              participantDialogOpen:true
            }
          })
        }
        else{
          this.submitData()
        }
      }
      else{
        this.submitData()
      }
	}

	componentDidMount() {
    console.log("node 22")
		this.setupInitialStep()
	}

  handleClose = () => {
    this.setState((state)=>{
      return {...state, participantDialogOpen:false}
    })
  };

  handleAcceptEnroll = ()=>{
    this.requestBody.participantId = this.matchedParticipant.id
    this.submitData()
    this.handleClose()
  }

  submitData = () => {
    this.handleClose()
    const participantForm = {
      ...this.state.participantData
    }
    // Encrypt Data
      if(participantForm.alien || !participantForm.ssn || participantForm.ssn.trim().length ===0){
        participantForm.ssn = ""
        participantForm.usePseudoSsn = 1
      }
      else{
        participantForm.usePseudoSsn = 0
      }

      if(this.props.activity && this.props.activity.serviceType === 'CAREER_EXPLORATION_ESSENTIAL_SKILLS' && this.props.activity.programType === 'REAL_SKILLS'){
        console.log(`Setting idDoc and idType as undefined as EmployRI API need not to be called for serviceType ${this.props.activity.serviceType} and programType ${this.props.activity.programType}`)
        participantForm.idDoc = undefined
        participantForm.idType = undefined
      }

			if(participantForm.idDoc && participantForm.idType &&  this.props.activity)
        {
				this.encryptSensitiveData(participantForm).then((p) => {
					this.requestBody.encryptedKey = p.key;
					this.requestBody.encryptedPayload = p.payload;
					createNewParticipant(this.requestBody)
						.then(this.onNewParticipantSuccess)
						.catch(this.handleUpdateFailure);
				});
			} else{

					createNewParticipant(this.requestBody)
						.then(this.onNewParticipantSuccess)
						.catch(this.handleUpdateFailure);
			}
  }

	public render() {
		const { classes, activity, t} = this.props
		const { currentStep, participantData } = this.state
    // const activityName : string = this.matchedParticipant? this.matchedParticipant.lastActivity:''
    // const lastActivityEnrollmentDate: string = this.matchedParticipant? this.matchedParticipant.lastActivityEnrollmentDate:''
		return (
			<div className={classes.root}>
        <Dialog
          open={this.state.participantDialogOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Typography variant="h6" component="h6" data-auto="survey-header">
              {t("main.participantFound.title")}
              <br/>
              {t("main.participantFound.firstName")}: {this.matchedParticipant?this.matchedParticipant.first_name:''}
              <br/>
              {t("main.participantFound.lastName")}: {this.matchedParticipant?this.matchedParticipant.last_name:''}
              <br/>
              {t("main.participantFound.previousActivityName")}: {this.matchedParticipant?this.matchedParticipant.lastActivity:''}
              <br/>
              {t("main.participantFound.dateofPreviousEnrollment")}: {this.matchedParticipant?new Date(this.matchedParticipant.lastActivityEnrollmentDate).toLocaleDateString('en-us',{month:"long",day:"numeric", year:"numeric"}):'' }
            </Typography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button id="accept-enroll" onClick={this.handleAcceptEnroll}>{t("main.acceptEnroll")}</Button>
            <Button id="reject-enroll" onClick={this.submitData}>{t("main.rejectEnroll")}</Button>
          </DialogActions>
      </Dialog>
				<div hidden={!this.state.loading}>
					<CircularProgress className={classes.loader} size={50} />
				</div>
				<section>
					<Stepper
						activeStep={currentStep}
						alternativeLabel={true}
						style={{ backgroundColor: 'transparent' }}
						data-auto="stepper"
					>
						{STEPS.map((label) => (
							<Step key={label} data-auto={`step-${label}`} style={{ paddingRight: '8px'}}>
								<StepLabel classes={{ label: classes.stepLabel }} data-auto={`step-label-${label}`}>
									{t(label)}
								</StepLabel>
							</Step>
						))}
					</Stepper>

					<div className={classes.slidesContainer}>
						<CustomSlide slideStep={0} currentStep={currentStep}>
							<Instructions
								activityName={activity!.activityName}
								nextStep={() => {this.moveStep('left', 1)}} />
						</CustomSlide>

						{/* RJRI-158: Eligibility section disabled until further notice
            <CustomSlide slideStep={1} currentStep={currentStep}>
							<EligibilityForm
                activity={activity}
								participant={participantData}
								updateParticipantHandler={this.updateParticipantData}
								next={() => {this.moveStep('left', 2)}}
								back={() => {this.moveStep('right', 0)}}
              />
						</CustomSlide>
						*/}

						<CustomSlide slideStep={1} currentStep={currentStep} >
							<PersonalInfoForm
                activity={activity}
								participant={participantData}
								updateParticipantHandler={this.updateParticipantData}
								next={() => {this.moveStep('left', 2)}}
								back={() => {this.moveStep('right', 0)}}
							/>
						</CustomSlide>



						<CustomSlide slideStep={2} currentStep={currentStep} >
							<FileUploadForm
              activity={activity}
								participant={participantData}
								updateParticipantHandler={this.updateParticipantData}
								next={() => {this.moveStep('left', 3)}}
								back={() => {this.moveStep('right', 1)}}
							/>
						</CustomSlide>



						<CustomSlide slideStep={3} currentStep={currentStep} >
							<SurveyData
              activity={activity}
								participant={participantData}
								participantType={activity!.participantType}
								backToWork={activity!.backToWork}
								updateParticipantHandler={this.updateParticipantData}
								next={() => {this.moveStep('left', 4)}}
								back={() => {this.moveStep('right', 2)}}
							/>
						</CustomSlide>



						<CustomSlide slideStep={4} currentStep={currentStep} >
							<ConfirmParticipantInfo
              activity={activity}
								participant={participantData}
								participantType={activity!.participantType}
								backToWork={activity!.backToWork}
								updateParticipantHandler={this.updateParticipantData}
								next={this.handleParticipantSubmit}
								back={() => {this.moveStep('right', 3)}}
								locked={this.state.loading}
							/>
						</CustomSlide>



						<CustomSlide slideStep={5} currentStep={currentStep} style={{ display: 'flex'}}>
							<div
								style={{
									display: 'flex',
									flexDirection: 'column',
									minHeight: '25vh',
									justifyContent: 'center',
									alignItems: 'center',
									flex: 1
								}}
							>
								<Typography
									variant="h4"
									component="p"
									align="center"
									className={classes.typography}
									data-auto="end-message"
								>
									{t(this.handleFinalMessage())}
								</Typography>
								<Typography variant="subtitle1" align="center" className={classes.typography} data-auto="end-message">
                  {t(this.handleEndMessage())}
								</Typography>
							</div>
						</CustomSlide>
					</div>
				</section>
			</div>
		)
	}
}

const styles = (theme: Theme) =>
	createStyles({
		root: {
			margin: '0 auto',
			padding: `${theme.spacing.unit}px} ${theme.spacing.unit * 2}px}`,
			display: 'flex',
		},
		slidesContainer: {
			flex: 1,
			justifyContent: 'row',
		},
		typography: {
			padding: `0 ${theme.spacing.unit * 1.5}px`,
			[theme.breakpoints.down('sm')]: {
				fontSize: theme.typography.h6.fontSize,
			},
		},
		stepLabel: {
			[theme.breakpoints.down('sm')]: {
				display: 'none',
			},
		},
		loader: {
     position: 'absolute',
     top: '50%',
     left: '50%',
     marginTop: '-20px',
     marginLeft: '-20px',
     zIndex: 2000
  	},
	})

export default withTranslation()(withStyles(styles)(Main))
